import { render, staticRenderFns } from "./warehouse-merge-duplicates-modal.vue?vue&type=template&id=4bc760a2"
import script from "./warehouse-merge-duplicates-modal.vue?vue&type=script&lang=js"
export * from "./warehouse-merge-duplicates-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports